/**
 * PRECOMPUTED (baked) OKLCH scales for the ACTIVE brand "securities" — GENERATED FILE.
 * Produced by scripts/bakeScales.js from configs/_shared/securities/theme.js.
 * Keeps culori out of the app bundles; the golden snapshot pins these values.
 * Do not hand-edit — re-run the bake (or switch brands).
 */
export const ACTIVE_LIGHT = {
  "blue": {
    "50": "#f6fbff",
    "60": "#deefff",
    "100": "#cbe6ff",
    "200": "#98cbfa",
    "300": "#6eace4",
    "400": "#438ece",
    "500": "#0973ba",
    "600": "#005c98",
    "700": "#004878",
    "800": "#00375e",
    "900": "#002847",
    "950": "#001c34",
    "DEFAULT": "#0973ba"
  },
  "orange": {
    "50": "#fff9f5",
    "100": "#ffe9de",
    "200": "#ffd6c1",
    "300": "#ffc0a0",
    "400": "#ffa97c",
    "500": "#f79764",
    "600": "#bf744c",
    "700": "#8f5638",
    "800": "#663c26",
    "900": "#442718",
    "950": "#28150c",
    "DEFAULT": "#f79764"
  },
  "gray": {
    "50": "#f8fafc",
    "100": "#e2e3e5",
    "200": "#c6c8ca",
    "300": "#a9abad",
    "400": "#8d8f91",
    "500": "#747678",
    "600": "#5c5e60",
    "700": "#47494b",
    "800": "#353738",
    "900": "#262729",
    "950": "#191b1c",
    "DEFAULT": "#747678"
  },
  "green": {
    "50": "#f0fff2",
    "100": "#bdffc9",
    "200": "#8ef6a5",
    "300": "#70e58d",
    "400": "#4ed474",
    "500": "#22c55e",
    "600": "#169947",
    "700": "#0c7333",
    "800": "#055323",
    "900": "#013815",
    "950": "#002209",
    "DEFAULT": "#22c55e"
  },
  "red": {
    "50": "#fff8f8",
    "100": "#ffdfdb",
    "200": "#ffbeb7",
    "300": "#ff978e",
    "400": "#ff6862",
    "500": "#ef4444",
    "600": "#bf3132",
    "700": "#962022",
    "800": "#721115",
    "900": "#54050a",
    "950": "#3a0003",
    "DEFAULT": "#ef4444"
  },
  "yellow": {
    "50": "#fff9f3",
    "100": "#ffebd4",
    "200": "#ffd9ae",
    "300": "#ffc47f",
    "400": "#ffae42",
    "500": "#f59e0b",
    "600": "#bd7a0b",
    "700": "#8d5a09",
    "800": "#653f07",
    "900": "#432904",
    "950": "#271703",
    "DEFAULT": "#f59e0b"
  },
  "purple": {
    "50": "#fbf9ff",
    "100": "#ede0ff",
    "200": "#dcc1ff",
    "300": "#ca9fff",
    "400": "#b978ff",
    "500": "#a855f7",
    "600": "#8540c7",
    "700": "#672d9d",
    "800": "#4e1d79",
    "900": "#380f5a",
    "950": "#260441",
    "DEFAULT": "#a855f7"
  },
  "emerald": {
    "50": "#eefff6",
    "100": "#afffd8",
    "200": "#8fefc2",
    "300": "#6edcab",
    "400": "#49ca95",
    "500": "#10b981",
    "600": "#039163",
    "700": "#006d4a",
    "800": "#004f35",
    "900": "#003623",
    "950": "#002114",
    "DEFAULT": "#10b981"
  },
  "indigo": {
    "50": "#f9faff",
    "100": "#dde3ff",
    "200": "#bdc6ff",
    "300": "#9ba6ff",
    "400": "#7b84ff",
    "500": "#6366f1",
    "600": "#4e4fc5",
    "700": "#3b3b9e",
    "800": "#2b297d",
    "900": "#1e1b60",
    "950": "#130e49",
    "DEFAULT": "#6366f1"
  },
  "pink": {
    "50": "#fff8fa",
    "100": "#ffdeea",
    "200": "#ffbdd6",
    "300": "#ff95c1",
    "400": "#fd68ad",
    "500": "#ec4899",
    "600": "#bc3578",
    "700": "#92245b",
    "800": "#6e1543",
    "900": "#4f082e",
    "950": "#36011d",
    "DEFAULT": "#ec4899"
  },
  "gold": {
    "50": "#fff9f3",
    "100": "#ffebd4",
    "200": "#ffd9ae",
    "300": "#ffc47f",
    "400": "#ffae42",
    "500": "#f59e0b",
    "600": "#bd7a0b",
    "700": "#8d5a09",
    "800": "#653f07",
    "900": "#432904",
    "950": "#271703",
    "DEFAULT": "#f59e0b"
  }
};

export const ACTIVE_DARK = {
  "blue": {
    "50": "#000e1e",
    "60": "#00162a",
    "100": "#001c34",
    "200": "#002f52",
    "300": "#004574",
    "400": "#005d99",
    "500": "#0973ba",
    "600": "#4892d1",
    "700": "#71aee6",
    "800": "#94c8f8",
    "900": "#bbdeff",
    "950": "#e2f1ff",
    "DEFAULT": "#0973ba"
  },
  "orange": {
    "50": "#170903",
    "100": "#341d11",
    "200": "#5e3723",
    "300": "#8f5638",
    "400": "#c4774e",
    "500": "#f79764",
    "600": "#ffa97d",
    "700": "#ffbd9c",
    "800": "#ffceb6",
    "900": "#ffddcc",
    "950": "#ffeadf",
    "DEFAULT": "#f79764"
  },
  "gray": {
    "50": "#0c0d0f",
    "100": "#1c1d1f",
    "200": "#313234",
    "300": "#4a4b4d",
    "400": "#646667",
    "500": "#7d7f81",
    "600": "#97999b",
    "700": "#afb1b3",
    "800": "#c6c8ca",
    "900": "#dbdcde",
    "950": "#edeff1",
    "DEFAULT": "#7d7f81"
  },
  "green": {
    "50": "#001204",
    "100": "#002b0e",
    "200": "#034c1f",
    "300": "#0c7333",
    "400": "#179d49",
    "500": "#22c55e",
    "600": "#50d576",
    "700": "#6ee48b",
    "800": "#86f29e",
    "900": "#9bfdaf",
    "950": "#c7ffd1",
    "DEFAULT": "#22c55e"
  },
  "red": {
    "50": "#220001",
    "100": "#420004",
    "200": "#670d11",
    "300": "#941f22",
    "400": "#c23233",
    "500": "#ef4444",
    "600": "#ff6d66",
    "700": "#ff978f",
    "800": "#ffb7b0",
    "900": "#ffd2cd",
    "950": "#ffe9e6",
    "DEFAULT": "#ef4444"
  },
  "yellow": {
    "50": "#160a00",
    "100": "#341f03",
    "200": "#5d3a06",
    "300": "#8e5a09",
    "400": "#c27d0b",
    "500": "#f59e0b",
    "600": "#ffaf44",
    "700": "#ffc278",
    "800": "#ffd29e",
    "900": "#ffdfbc",
    "950": "#ffebd5",
    "DEFAULT": "#f59e0b"
  },
  "purple": {
    "50": "#160029",
    "100": "#2a0647",
    "200": "#46186e",
    "300": "#662c9a",
    "400": "#8841ca",
    "500": "#a855f7",
    "600": "#bb7cff",
    "700": "#ca9fff",
    "800": "#d9bcff",
    "900": "#e6d5ff",
    "950": "#f2eaff",
    "DEFAULT": "#a855f7"
  },
  "emerald": {
    "50": "#001209",
    "100": "#002919",
    "200": "#00482f",
    "300": "#006d4a",
    "400": "#039466",
    "500": "#10b981",
    "600": "#4ccb96",
    "700": "#6ddcaa",
    "800": "#87ebbc",
    "900": "#9ef8cd",
    "950": "#c1ffe0",
    "DEFAULT": "#10b981"
  },
  "indigo": {
    "50": "#080331",
    "100": "#14104d",
    "200": "#252371",
    "300": "#39399b",
    "400": "#4f50c7",
    "500": "#6366f1",
    "600": "#7e88ff",
    "700": "#9ca7ff",
    "800": "#b8c2ff",
    "900": "#d3d9ff",
    "950": "#eaedff",
    "DEFAULT": "#6366f1"
  },
  "pink": {
    "50": "#20000f",
    "100": "#3e0322",
    "200": "#64113c",
    "300": "#90235a",
    "400": "#bf367a",
    "500": "#ec4899",
    "600": "#fe6baf",
    "700": "#ff95c1",
    "800": "#ffb6d2",
    "900": "#ffd1e2",
    "950": "#ffe7f0",
    "DEFAULT": "#ec4899"
  },
  "gold": {
    "50": "#160a00",
    "100": "#341f03",
    "200": "#5d3a06",
    "300": "#8e5a09",
    "400": "#c27d0b",
    "500": "#f59e0b",
    "600": "#ffaf44",
    "700": "#ffc278",
    "800": "#ffd29e",
    "900": "#ffdfbc",
    "950": "#ffebd5",
    "DEFAULT": "#f59e0b"
  }
};

export const ACTIVE_META = {
  "brandKey": "securities",
  "heroStyle": "brand",
  "heroAccent": "#ffffff"
};
